module.exports = __webpack_public_path__ + "img/padlock_white.66a82a8b.png";